import { render, staticRenderFns } from "./familyTitle.vue?vue&type=template&id=7bce217a&scoped=true&"
import script from "./familyTitle.vue?vue&type=script&lang=js&"
export * from "./familyTitle.vue?vue&type=script&lang=js&"
import style0 from "./familyTitle.vue?vue&type=style&index=0&id=7bce217a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bce217a",
  null
  
)

export default component.exports